import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';

/**
 * loadingInterceptor
 * ──────────────────
 * Detecta peticiones HTTP de mutación (POST, PUT, DELETE, PATCH)
 * y dispara automáticamente el LoadingService para bloquear la UI.
 */
export function loadingInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const loadingService = inject(LoadingService);

  // Métodos que alteran estado (Crear, Editar, Eliminar, Anular)
  const isMutation = ['POST', 'PUT', 'DELETE', 'PATCH'].includes(req.method);
  const skipLoading = req.headers.has('x-skip-loading');

  if (isMutation && !skipLoading) {
    loadingService.showLoading(
      'Procesando solicitud',
      'Por favor espera un momento...'
    );
  }

  return next(req).pipe(
    finalize(() => {
      if (isMutation && !skipLoading) {
        loadingService.hideLoading();
      }
    })
  );
}
